import { Box, Skeleton, Typography } from "@mui/material";
import { toToman } from "../../utils/Utils";
import { ReactComponent as WalletWhiteIcon } from "../../assets/icons/wallet-white.svg";
import { ReactComponent as WalletArrowWhiteIcon } from "../../assets/icons/wallet-arrow-white.svg";
import { bgcolor } from "@mui/system";
import { useNavigate } from "react-router-dom";
import CustomTextSkeleton from "../shared/CustomTextSkeleton";

function HomeWalletCard(props) {
  const { amount = 0, loading } = props;
  const navigate = useNavigate();
  return (
    <Box
      sx={{
        width: "100%",
        px: "24px",
        mt: "12px",
      }}
    >
      <Box
        sx={{
          width: "100%",
          minHeight: 42,
          px: "8px",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          borderRadius: "8px",
          border: (theme) => `1px solid ${theme.palette.primary.light}`,
        }}
      >
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            height: "100%",
          }}
        >
          <WalletWhiteIcon width={18} height={15} />
          <Typography ml={"4px"} variant="subtitle1" color="common.white">
            {loading ? (
              <CustomTextSkeleton width={100} />
            ) : (
              `موجودی: ${toToman(amount)} تومان`
            )}
          </Typography>
        </Box>
        <Box
          onClick={() => {
            navigate("/app/wallet");
          }}
          sx={{
            minHeight: 32,
            px: "18px",
            borderRadius: "8px",
            bgcolor: "primary.main",
            display: "flex",
            alignItems: "center",
          }}
        >
          <WalletArrowWhiteIcon width={24} height={24} />
          <Typography ml={"8px"} variant="subtitle1" color="common.white">
            قلک من
          </Typography>
        </Box>
      </Box>
    </Box>
  );
}

export default HomeWalletCard;
